// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"4a354c25","603":"5828c3ef","695":"ab507775"}[chunkId] + ".chunk.css";
};